module.exports = __webpack_public_path__ + "images/a88b1c5845f2bc398057645b0f445829.jpg";


//////////////////
// WEBPACK FOOTER
// ../public/images/spirits-hover.jpg
// module id = 858
// module chunks = 0